import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import ResidentReportDetail from './index.vue';

const MOUNT_ID = 'residentReportDetailApp';

let residentReportDetailApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

export function initResidentReportDetail(root?: ParentNode): void {
  const mountEl = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (!mountEl) {
    return;
  }

  if (residentReportDetailApp && currentMountEl) {
    residentReportDetailApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(ResidentReportDetail);
  app.use(AntDesignVue).mount(mountEl);

  residentReportDetailApp = app;
  currentMountEl = mountEl;
}

export {
  getReportDetailHref,
  getReportEditHref,
  getReportIdFromUrl,
  getReportListHref,
  navigateToReportList,
  RESIDENT_LK_REPORTS_TAB_ID,
} from './get-report-id-from-url';
export { mapApiReportToEditPayload } from './map-report-detail';
